import { eachDayOfInterval, endOfWeek, format, startOfWeek } from 'date-fns'
import { enUS } from 'date-fns/locale'

/** Normalizuje kody dni (np. z API) do formatu używanego przez przyciski (Pierwsza wielka, reszta małe). */
export const formatDays = (days: string[]) =>
  days.map(day => day.charAt(0) + day.slice(1).toLowerCase())

/** Zwraca 7 dni tygodnia (pn–nd): nazwa do tłumaczenia + stała angielska jako `value` przycisku. */
export function getWeekdayToggleOptions(): Array<{
  localizedName: string
  englishName: string
}> {
  return eachDayOfInterval({
    start: startOfWeek(new Date(), { weekStartsOn: 1 }),
    end: endOfWeek(new Date(), { weekStartsOn: 1 }),
  }).map(date => ({
    localizedName: format(date, 'iiiiii'),
    englishName: format(date, 'iiiiii', { locale: enUS }),
  }))
}

/** Tryb „wiele”: dodaje lub usuwa kliknięty dzień z wyboru. */
export const toggleDay = (selectedDays: string[], clickedDay: string) => {
  if (selectedDays.includes(clickedDay)) {
    return selectedDays.filter(day => day !== clickedDay)
  }

  return [...selectedDays, clickedDay]
}
